import Event from "@components/event/Event";

const EventPageByCode = ({ siteConfig }) => {
  // siteConfig를 써야 한다면 여기서 Event에 prop으로 내려주면 됨
  return <Event />;
};

export default EventPageByCode;
